import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
    <title></title>

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.92889 4.92889C6.80426 3.05352 9.34782 1.99995 12 1.99995C14.6522 1.99995 17.1957 3.05352 19.0711 4.92889C20.9465 6.80427 22 9.34782 22 12C22 14.6522 20.9465 17.1957 19.0711 19.0711C17.1957 20.9465 14.6522 22.0001 12 22.0001C9.34782 22.0001 6.80426 20.9465 4.92889 19.0711C3.05351 17.1957 1.99994 14.6522 1.99994 12C1.99994 9.34782 3.05351 6.80427 4.92889 4.92889ZM7.09455 5.68035L18.3196 16.9054C19.4031 15.5097 20 13.7856 20 12C20 9.87826 19.1572 7.84341 17.6569 6.34311C16.1566 4.84281 14.1217 3.99995 12 3.99995C10.2144 3.99995 8.49027 4.59692 7.09455 5.68035ZM16.9054 18.3197L5.68034 7.09456C4.59691 8.49027 3.99994 10.2144 3.99994 12C3.99994 14.1217 4.8428 16.1566 6.3431 17.6569C7.8434 19.1572 9.87825 20.0001 12 20.0001C13.7856 20.0001 15.5097 19.4031 16.9054 18.3197Z"
    />
  </svg>
);

const BanIcon = (props) => <Icon component={SVG} {...props} />;

export default BanIcon;
